export const check = `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
viewBox="0 0 511.999 511.999" style="enable-background:new 0 0 511.999 511.999;" xml:space="preserve">
<g>
<g>
   <path d="M509.012,113.243l-60.754-60.755c-3.983-3.983-10.442-3.983-14.424,0L169.957,316.368l-91.793-91.793
       c-1.912-1.912-4.507-2.987-7.212-2.987s-5.299,1.075-7.212,2.987L2.987,285.328c-3.983,3.984-3.983,10.442,0,14.425
       L162.745,459.51c1.992,1.992,4.602,2.987,7.212,2.987c2.61,0,5.221-0.995,7.212-2.987l331.843-331.843
       C512.995,123.684,512.995,117.226,509.012,113.243z M169.957,437.875L24.623,292.541l46.33-46.331l91.793,91.793
       c3.982,3.983,10.441,3.983,14.424,0L441.047,74.125l46.33,46.33L169.957,437.875z"/>
</g>
</g>
<g>
<g>
   <path d="M437.546,142.761c-3.984-3.983-10.442-3.983-14.425,0l-74.423,74.423c-3.983,3.984-3.983,10.442,0,14.425
       c1.991,1.992,4.602,2.987,7.212,2.987s5.22-0.996,7.213-2.987l74.423-74.423C441.528,153.202,441.529,146.744,437.546,142.761z"/>
</g>
</g>
<g>
<g>
   <path d="M464.647,115.687c-3.984-3.983-10.442-3.983-14.425,0l-2.55,2.55c-3.983,3.984-3.983,10.442,0,14.425
       c1.991,1.992,4.602,2.987,7.212,2.987c2.61,0,5.221-0.995,7.213-2.987l2.55-2.55C468.63,126.128,468.63,119.67,464.647,115.687z"
       />
</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>`;